export default function specific({ selector, style }) {
    const newSelector = selector
        .split(',')
        .map(s => `:not(#specific) ${s}`)
        .join(',');

    return { selector: newSelector, style };
}



// WEBPACK FOOTER //
// ./src/styles/plugins/specific.js